import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useRegions = (enabled = true) => {
    const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
    return useQuery({
        queryKey: ['regions'],
        queryFn: async () => {
            const result = await restClient({ url: `${prefix}/regions` });
            return result;
        },
        enabled,
        staleTime: 5 * 60 * 1000
    });
};
